(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcement-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.announcement-slider').forEach(slider => {
    const slides = slider.querySelectorAll('.announcement-slide');
    if (slides.length < 2) return;

    let index = 0;
    const interval = (parseInt(slider.dataset.interval, 10) || 3) * 1000;

    setInterval(() => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
